import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

import QuillEditor from '../../shared/QuillEditor/QuillEditor';

import ImageModal from './ImageModal/ImageModal';

import styles from './ReferralProgramDetails.module.scss';

export const ReferralProgramDetails = ({ termsAndConditions }) => {
  const { t } = useTranslation('referral');
  const sanitizedReferralProgramDetails = DOMPurify.sanitize(termsAndConditions?.referral_program_details);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="bg-white rounded-xl shadow-card">
      <div className="p-3 space-y-4">
        <p className="text-lg font-semibold mb-0">{t('programDetails')}</p>
        {termsAndConditions?.referral_program_image && (
          <button
            type="button"
            className="rounded-lg overflow-hidden w-full border-none bg-transparent"
            onClick={() => setIsModalOpen(true)}
            onKeyDown={(e) => e.key === 'Enter' && setIsModalOpen(true)}
          >
            <img
              src={termsAndConditions?.referral_program_image}
              alt="Referral rewards"
              className="w-full h-48 object-cover rounded-lg"
            />
          </button>
        )}
        <div className={`text-sm text-gray-600 ${styles.referralProgramDetails}`}>
          <QuillEditor value={sanitizedReferralProgramDetails} readOnly modules={{ toolbar: false }} />
        </div>
      </div>

      <ImageModal
        onClose={() => setIsModalOpen(false)}
        title={t('programDetails')}
        showModal={isModalOpen}
        imageUrl={termsAndConditions?.referral_program_image}
      />
    </div>
  );
};
